import angular from 'angular';

(global => {
  class MailOrderPharmacies {
    constructor($log, $http, Endpoints, API_URL, CMS_API_URL, serverless_api_url) {
      'ngInject';

      Object.assign(this, {
        $log,
        $http,
        Endpoints,
        API_URL,
        CMS_API_URL,
        serverless_api_url
      });
    }

    audit(auditInfo) {
      return this.$http.post(this.CMS_API_URL + `/admin/state-medication-pharmacy/audit`, auditInfo);
    }

    insert(medication_id, state_code, pharmacy_id, created) {
      return this.$http.post(this.CMS_API_URL + `/admin/state-medication-pharmacy`, {
        medication_id,
        state_code,
        pharmacy_id,
        created
      });
    }

    bulkAdd(payload) {
      return this.$http.post(this.serverless_api_url + `mailorderpharmacies/v1/admin/mailorderpharmacies`, payload);
    }

    listMedicationsByService(serviceCode) {
      return this.$http.get(this.CMS_API_URL + `/admin/medications/all/${serviceCode}`);
    }

    getAllPharmacies() {
      return this.$http.get(this.Endpoints.mailOrderPharmacies.baseGet);
    }

    getByState(stateCode) {
      return this.$http.get(this.API_URL + `/admin/medications/states/${stateCode}/mailorderpharmacies`, {
        loadingText: `Loading Information for ${stateCode}`
      });
    }

    getByService(stateCode, serviceCode) {
      return this.$http.get(this.API_URL + `/admin/medications/states/${stateCode}/mailorderpharmacies?service_code=${serviceCode}`, {
        loadingText: `Loading ${serviceCode} for ${stateCode}`
      });
    }

    updatePharmacies(medication, state, pharmacy) {
      return this.$http.put(this.API_URL + `/admin/medications/${medication}/states/${state}/mailorderpharmacy/`, {
        "pharmacy_id": pharmacy
      });
    }

  }

  MailOrderPharmacies.$inject = ["$log", "$http", "Endpoints", "API_URL", "CMS_API_URL", "serverless_api_url"];
  angular.module('pims').service('MailOrderPharmacies', MailOrderPharmacies);
  global.MailOrderPharmacies = MailOrderPharmacies;
})(window);